module.exports = __webpack_public_path__ + "static/media/transfer-CANCELLED.d737ce79.svg";